module.exports = __webpack_public_path__ + "img/male_resultE.ff7281cc.png";